<template>
  <div>
    <div v-if="!showResult">
      <form :model="form" class="contact-form-1"  >

        <div class="row row--30">
          <div class="form-group col-lg-6 col-md-6 col-sm-12" >

            <div class="el-form-item__content">
              <div class="el-input">
                <input
                    maxlength="20"
                    style="width: 100%;"
                    type="text"
                    name="fullname"
                    v-model="form.fullname"
                    placeholder="请输入您的称呼"
                    required
                />
              </div>

            </div>
          </div>
          <div class="form-group col-lg-6 col-md-6 col-sm-12">


            <div class="el-form-item__content">
              <div class="el-input">
                <input
                    maxlength="13"
                    type="text"
                    name="phone"
                    v-model="form.phone"
                    placeholder="请输入您的联系方式"
                    required
                />
              </div>

            </div>
          </div>

          <div class="form-group col-lg-12 col-md-12 col-sm-12">

            <div class="el-form-item__content">
              <div class="el-input">
                        <textarea
                            maxlength="300"
                            v-model="form.message"
                            name="message"
                            placeholder="请填写您的留言信息"
                        >  </textarea>
              </div>
            </div>

          </div>


        </div>
      </form>

      <div  v-if="!isDisabled">
        <div class="col-lg-12 col-md-12 col-sm-12">


          <div class="el-form-item__content">
            <div class="el-input" style="text-align: center;">
              <button  class="btn-default btn-large" @click="submitForm">我 要 留 言</button>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="form-group" style="width: 100%" v-if="showResult" >

      <CallToAction
          :style-type="8"
          title="感谢您的留言!"
          subtitle=""
          btn-text="返回首页"
      />


    </div>



  </div>



</template>

<script>
import CallToAction from "../callToAction/CallToAction";

    export default {
        name: 'ContactForm',
      components: {CallToAction},
        data() {
            return {
                form:{
                  fullname: undefined,
                  phone: undefined,
                  message:undefined,
                  isDel: 0,
                  type: '2'
                },
              isDisabled:false,
              showResult: false,

            }
        },
        methods: {
          submitForm() {
            this.isDisabled = true;
            this.postRequest('/system/web/join',this.form).then(resp=>{
              if(resp.data.code === 200){
                this.showResult = true;
              }
            });

          }
        }
    }
</script>